import OpenAIAdapter from "./open-ai"
import XdcAdapter from "./xdc"

class Adapters {
    create(config: { type: string }) {
        const type = config.type

        switch (type) {
            case 'open-ai':
                return new OpenAIAdapter(config)
            case 'xdc':
                return new XdcAdapter(config)
            default:
                throw new Error(`Unknown adapter type: ${type}`)
        }
    }
}

export default new Adapters()